import React from "react";
import {
    Card, CardActions, CardContent, CardHeader,
    Divider, Button
} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(33, 33, 33, 0.45)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        position: 'relative',
        outline: 'none',
        boxShadow: theme.shadows[20],
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%',
        minWidth: 400,
        background: '#fff',
    },
    tableMarginTop: {
        marginTop: 24,
    },
    actions: {
        justifyContent: 'flex-end'
    },
    warning: {
        color: '#d32f2f',
        fontWeight: 600,
        marginBottom: 16,
        fontSize: 16,
    },
}));

const InvestorsDomainModal = ({onConfirm, onClose}) => {
    const classes = useStyles();

    // Custom warning messages
    const singleInvestorMsg =
        'Do you want to save it anyway?';

    return (
        <div className={classes.overlay}>
            <Card className={clsx(classes.root)}>
                <CardHeader className={classes.warning} title="The domain does not belong to the allowed domains"/>
                <Divider/>
                <CardContent>
                    <div >{singleInvestorMsg}</div>
                </CardContent>
                <Divider/>
                <CardActions className={classes.actions}>
                    <Button onClick={onConfirm} color="primary" variant="contained">Accept</Button>
                    <Button onClick={onClose}>Cancel</Button>
                </CardActions>
            </Card>
        </div>
    );
};

export default InvestorsDomainModal;
